/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { ID } from '@gh/common-shared-data';
import { AbstractRestService, identity, none, RestSettings } from '@gh/core-data';
import { Observable } from 'rxjs';
import { SupplierUserProfileDto, SupplierUserProfileUpdateDto } from './profiles.dto';
import { SupplierUserProfileMapper } from './profiles.mapper';

@Injectable()
export class SupplierUserProfileRestService extends AbstractRestService {

  constructor(private settings: RestSettings) {
    super(settings);
  }

  get(): Observable<SupplierUserProfileDto> {
    return this.httpGet('/profiles/me', SupplierUserProfileMapper);
  }

  update(profile: SupplierUserProfileUpdateDto): Observable<SupplierUserProfileDto> {
    return this.httpPut('/profiles', profile, identity(), SupplierUserProfileMapper);
  }

  logout(): Observable<any> {
    return this.httpGet('/profiles/logout', identity());
  }

  acceptInvitation(officeId: ID): Observable<void> {
    return this.httpGet(`/profiles/accept-invitation/${officeId}`, none());
  }
}
